export default __webpack_public_path__ + "static/media/angular.3fce8c76.svg";